import React from "react";
import { SupText } from "@repo/core-ui";

import { formatAddress } from "../../../../utils/transactions";
import { SupTxChain } from "../../TxChain";
import { SupTxFormattedValue } from "../../TxFormattedValue";
import type { AddressProps } from "../../types";

export function AddressValue({ address, chainLogo, chainName, chainUrl, onCopy }: AddressProps) {
  return (
    <SupText as="div" variant="button" className="inline-flex items-center gap-2 whitespace-nowrap">
      <SupTxFormattedValue value={address} formatter={formatAddress} onCopy={onCopy} />
      <span>on</span>
      <SupTxChain chainLogo={chainLogo} chainName={chainName} explorerUrl={chainUrl} />
    </SupText>
  );
}
